import { create, ApisauceInstance, ApiResponse } from 'apisauce';
import { TBB_BASE_URL } from './Constant';

// Lightweight client for the separate TBB (Tier/Billing Board) service.
// This is a different backend service (hosted separately from
// THOM_BASE_URL/USER_BASE_URL), so it uses its own apisauce instance.
export default class TbbApiClient {
  private static _instance: TbbApiClient;

  private readonly api: ApisauceInstance;

  constructor() {
    this.api = create({
      baseURL: TBB_BASE_URL,
    });

    this.api.addRequestTransform((request) => {
      if (request?.headers) {
        request.headers = {
          ...request.headers,
          Authorization: `Bearer ${localStorage?.getItem('accessToken')}`,
        };
      }
      return request;
    });
  }

  public static getInstance(): TbbApiClient {
    return this._instance ?? (this._instance = new TbbApiClient());
  }

  async get<T>(url: string, params?: object): Promise<ApiResponse<T>> {
    return this.api.get<T>(url, params);
  }

  async post<T, U>(url: string, payload?: T): Promise<ApiResponse<T, U>> {
    return this.api.post<T, U>(url, payload);
  }
}
